import type { FunctionComponent } from 'react';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';
import withContextItems from '@iconik-io/web/src/components/modals/context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '@iconik-io/web/src/components/modals/modals_manager/types';

import { assetRelationsReverse } from '../../../ducks/asset_relations/actions';
import type { RelationTarget } from '../../../ducks/asset_relations/types';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../store/react_redux_typed';
import ControlsModal from '../../../ui/controls_modal/controls_modal';

type Props = ContextItemsHocProps<{
  searchItem: SearchItemEntity;
  relation: RelationTarget;
}> &
  ModalComponentProps;

const ReverseRelationModal: FunctionComponent<Props> = ({
  isOpen,
  onConfirm,
  onCancel,
  ...props
}) => {
  const { searchItem, relation } = props.item;

  const dispatch = useAppDispatch();
  const labels = useAppSelector(
    (state) => state.assetRelations.relationsLabels,
  );
  const handleConfirm = (): Promise<unknown> => {
    dispatch(assetRelationsReverse(searchItem, relation));
    onConfirm();
    return Promise.resolve();
  };
  const reverseLabel =
    Object.values(labels[relation.relationType]).find(
      (item) => item !== relation.label,
    ) || '';

  return (
    <ControlsModal
      headerText="Reverse relation"
      confirmButtonText="Reverse relation"
      variant="warning"
      isOpen={isOpen}
      onOpen={() => true}
      onAfterClose={() => true}
      onCancel={onCancel}
      onConfirm={handleConfirm}
      isForm
    >
      {`Are you sure you want reverse this relation to ${reverseLabel}?`}
    </ControlsModal>
  );
};

export default withContextItems(ReverseRelationModal);
